<template>
  <div>
  <div v-if="confirmedUserAnswer" class="container-reset-password">
  <div tabindex="0" class="e-card">
    <div class="e-card-title"> Update Password </div>
    <div class="e-card-content margin-color-verify-section">
      <web-login-info
                      ref="refwebLoginInfo"
                      :userProfileId="userId"
                      :userProfilesData="getUserDetail" />
      <security-questions
              v-if="enableSecurityQuestions"
              ref="refSecurityQuestions"
              :user-profile-id="userId"
              :user-profiles-data="currentUser"
            />
      <div class="align-center-bottom">
        <ejs-button v-on:click.native="onCancelButtonClick"
                      cssClass="e-danger margin-button">Cancel</ejs-button>
        &nbsp;&nbsp;
        <ejs-button type="button" v-on:click.native="btnComplete"
                      cssClass="e-info margin-button">Submit</ejs-button>
      </div>
    </div>
    </div>
    </div>
  </div>
  </template>

<script>
import WebLoginInfo from '../../user-accounts/components/web-login-info.vue';
import SecurityQuestions from "../../user-accounts/components/security-questions.vue";

export default {
  name: 'ResetPasswordWihtouSecurityQuestions',
  components: {
    WebLoginInfo,
    SecurityQuestions,
  },
  data() {
    return {
      // tempTokenErrorMessage: null,
      questionVerificationMessage: null,
      confirmedUserAnswer: true,
      failAttempt: 0,
      questionCount: 3,
    };
  },
  created() {
    this.enableSecurityQuestions = true;
  },
  computed: {
    // userSequrityQuestions() {
    //   return this.$store.getters.userserSecurityQuestions || [];
    // },
    confirmedUserName() {
      return this.$store.getters.confirmedUserName;
    },
    currentUser() {
      return this.$store.getters.loggedUser
        ? this.$store.getters.loggedUser
        : null;
    },
    getUserDetail() {
      return this.$store.getters.confirmedUser;
    },
    userId() {
      return this.$store.getters.confirmedUser.userId;
    },
  },
  methods: {
    notify(type, message) {
      this.$parent.notificationToasts.push({
        title: type,
        content: message,
        cssClass: type === 'Error' ? 'e-toast-danger' : 'e-toast-success',
        timeOut: 5000,
      });
      if (this.$parent.notificationToasts.length > 0) {
        this.$parent.$refs.notifierRef.show();
      }
    },
    onCancelButtonClick() {
      this.$router.push('/');
    },
    btnComplete() {
      const loginInfo = this.$refs.refwebLoginInfo;
      const securityQuestion = this.$refs.refSecurityQuestions;
      let notificationContent = '';
      let isFormValid = false;
      // --Leo. this loginInfo.isConfirmPassword always return ture.
      // -- not fixed, just bring showConfirmPasswordMatch to join check for now.
      if (!loginInfo.isPasswordValid || !loginInfo.isConfirmPassword
      || !loginInfo.showConfirmPasswordMatch) {
        notificationContent = 'Please enter correct passwod.<br>';
      }

      if (this.enableSecurityQuestions) {
        const inValidFields = [];
        const { isSecurityAnswerOne } = securityQuestion;
        const { isSecurityAnswerTwo } = securityQuestion;
        const { isSecurityAnswerThree } = securityQuestion;
        const { isConfirmAnswerOne } = securityQuestion;
        const { isConfirmAnswerTwo } = securityQuestion;
        const { isConfirmAnswerThree } = securityQuestion;

        isFormValid = isSecurityAnswerOne
            && isSecurityAnswerTwo
            && isSecurityAnswerThree
            && isConfirmAnswerOne
            && isConfirmAnswerTwo
            && isConfirmAnswerThree
            && loginInfo.isPasswordValid
            && loginInfo.isConfirmPassword;

        if (!isSecurityAnswerOne || !isConfirmAnswerOne) {
          inValidFields.push("Answer 1");
          notificationContent += 'Double check Security Question 1 <br>';
        }
        if (!isSecurityAnswerTwo || !isConfirmAnswerTwo) {
          inValidFields.push("Answer 2");
          notificationContent += 'Double check Security Question 2 <br>';
        }
        if (!isSecurityAnswerThree || !isConfirmAnswerThree) {
          inValidFields.push("Answer 3");
          notificationContent += 'Double check Security Question 3 <br>';
        }

        if (isFormValid) {
          securityQuestion.securityQuestions();
          notificationContent = "Security questions updated successfully;";
        } else {
          securityQuestion.validateSecurityQuestions();
        }
      }

      if (isFormValid && loginInfo.isPasswordValid && loginInfo.isConfirmPassword) {
        loginInfo.resetPassword();
        notificationContent += "password has successfully changed;";
        this.notify('Success', notificationContent);
        this.$router.push('/login');
      } else {
        loginInfo.validatePassword();
        this.notify("Error", notificationContent);
      }
    },
  },
};
</script>
  <style>
  .container-reset-password {
    padding: 16px 10% 16px 10%;
  }
  </style>
